import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { HomeOutlined, ReloadOutlined } from '@ant-design/icons';
import { useAuth } from '../AuthContext';

const t = {
  ar: {
    code: '500',
    title: 'حدث خطأ غير متوقع',
    body: 'فريقنا تم إشعاره وسيتم إصلاح المشكلة قريباً. حاول إعادة المحاولة أو عُد لاحقاً.',
    retry: 'إعادة المحاولة',
    home: 'الصفحة الرئيسية',
    contact: 'تواصل مع الدعم',
  },
  en: {
    code: '500',
    title: 'Something went wrong',
    body: 'Our team has been notified and is working on a fix. Try again, or come back in a moment.',
    retry: 'Try again',
    home: 'Home',
    contact: 'Contact support',
  },
};

export default function ServerError({ lang: langProp, onRetry, error }) {
  const auth = useAuth() || {};
  const lang = langProp || auth.lang || 'ar';
  const tx = t[lang] || t.ar;
  const retry = () => (onRetry ? onRetry() : window.location.reload());

  return (
    <div className="error-page" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <div className="error-card glass-strong animate-pop">
        <div className="error-code grad-text-amber">{tx.code}</div>
        <h1 className="error-title">{tx.title}</h1>
        <p className="error-body">{tx.body}</p>

        <div className="error-actions">
          <Button type="primary" size="large" icon={<ReloadOutlined />} onClick={retry}>{tx.retry}</Button>
          <Link to="/"><Button size="large" icon={<HomeOutlined />}>{tx.home}</Button></Link>
          <Link to="/help"><Button size="large">{tx.contact}</Button></Link>
        </div>

        {error && process.env.NODE_ENV !== 'production' && (
          <pre className="error-details">{String(error)}</pre>
        )}
      </div>
    </div>
  );
}
